"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferTypes = exports.DeliveryReturnReason = exports.SalesCustomerTypes = exports.CustomerTypes = exports.ApplicationDevices = exports.IProductSupplier = exports.PlantStates = exports.ActiveIngredients = exports.AdditiveTypes = exports.PackageTypes = exports.ProductCategories = exports.UnitsOfMeasureAbbreviations = exports.UnitsOfMeasure = exports.LabTestNames = void 0;
var LabTestNames;
(function (LabTestNames) {
    LabTestNames["THC"] = "THC";
    LabTestNames["THCa"] = "THCa";
    LabTestNames["CBD"] = "CBD";
    LabTestNames["CBDa"] = "CBDa";
    LabTestNames["Pesticides"] = "Pesticides";
})(LabTestNames = exports.LabTestNames || (exports.LabTestNames = {}));
var UnitsOfMeasure;
(function (UnitsOfMeasure) {
    UnitsOfMeasure["Ounces"] = "Ounces";
    UnitsOfMeasure["Gallons"] = "Gallons";
    UnitsOfMeasure["Each"] = "Each";
    UnitsOfMeasure["Pounds"] = "Pounds";
    UnitsOfMeasure["Grams"] = "Grams";
    UnitsOfMeasure["Milligrams"] = "Milligrams";
    UnitsOfMeasure["Kilograms"] = "Kilograms";
})(UnitsOfMeasure = exports.UnitsOfMeasure || (exports.UnitsOfMeasure = {}));
var UnitsOfMeasureAbbreviations;
(function (UnitsOfMeasureAbbreviations) {
    UnitsOfMeasureAbbreviations["oz"] = "oz";
    UnitsOfMeasureAbbreviations["ea"] = "ea";
    UnitsOfMeasureAbbreviations["lb"] = "lb";
    UnitsOfMeasureAbbreviations["g"] = "g";
    UnitsOfMeasureAbbreviations["mg"] = "mg";
    UnitsOfMeasureAbbreviations["kg"] = "kg";
})(UnitsOfMeasureAbbreviations = exports.UnitsOfMeasureAbbreviations || (exports.UnitsOfMeasureAbbreviations = {}));
var ProductCategories;
(function (ProductCategories) {
    ProductCategories["Buds"] = "Buds";
})(ProductCategories = exports.ProductCategories || (exports.ProductCategories = {}));
var PackageTypes;
(function (PackageTypes) {
    PackageTypes["Product"] = "Product";
    PackageTypes["ImmaturePlant"] = "ImmaturePlant";
    PackageTypes["VegetativePlant"] = "VegetativePlant";
})(PackageTypes = exports.PackageTypes || (exports.PackageTypes = {}));
// GET /plants/v1/additives/types
var AdditiveTypes;
(function (AdditiveTypes) {
    AdditiveTypes["Fertilizer"] = "Fertilizer";
    AdditiveTypes["Pesticide"] = "Pesticide";
    AdditiveTypes["Other"] = "Other";
})(AdditiveTypes = exports.AdditiveTypes || (exports.AdditiveTypes = {}));
var ActiveIngredients;
(function (ActiveIngredients) {
    ActiveIngredients["Phosphorous"] = "Phosphorous";
    ActiveIngredients["Nitrogen"] = "Nitrogen";
    ActiveIngredients["Potassium"] = "Potassium";
})(ActiveIngredients = exports.ActiveIngredients || (exports.ActiveIngredients = {}));
var PlantStates;
(function (PlantStates) {
    PlantStates["Tracked"] = "Tracked";
})(PlantStates = exports.PlantStates || (exports.PlantStates = {}));
var IProductSupplier;
(function (IProductSupplier) {
    IProductSupplier["Monsanta"] = "Monsanta";
})(IProductSupplier = exports.IProductSupplier || (exports.IProductSupplier = {}));
var ApplicationDevices;
(function (ApplicationDevices) {
    ApplicationDevices["Spray"] = "Spray";
})(ApplicationDevices = exports.ApplicationDevices || (exports.ApplicationDevices = {}));
// GET /sales/v1/customertypes
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["Consumer"] = "Consumer";
    CustomerTypes["Patient"] = "Patient";
    CustomerTypes["Caregiver"] = "Caregiver";
    CustomerTypes["ExternalPatient"] = "ExternalPatient";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
var SalesCustomerTypes;
(function (SalesCustomerTypes) {
    SalesCustomerTypes["Consumer"] = "Consumer";
})(SalesCustomerTypes = exports.SalesCustomerTypes || (exports.SalesCustomerTypes = {}));
// GET /sales/v1/delivery/returnreasons?licenseNumber=123-ABC
var DeliveryReturnReason;
(function (DeliveryReturnReason) {
    DeliveryReturnReason["Spoilage"] = "Spoilage";
    DeliveryReturnReason["Theft"] = "Theft";
})(DeliveryReturnReason = exports.DeliveryReturnReason || (exports.DeliveryReturnReason = {}));
// GET /transfers/v1/types?licenseNumber=123-ABC
var TransferTypes;
(function (TransferTypes) {
    TransferTypes["Transfer"] = "Transfer";
    TransferTypes["Wholesale"] = "Wholesale";
})(TransferTypes = exports.TransferTypes || (exports.TransferTypes = {}));
//# sourceMappingURL=metrcInterfaces.js.map